import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const useGetAgeGroups = (params?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['age-groups'] as const,
    queryFn: async () => {
      const { data, error } = await supabaseApi.from('age_groups').select('*')
      if (error) throw error
      return data
    },
    enabled: params?.enabled,
  })
}
